// IBAN to view style DE45 012 345 678 ...
export const formatIban = (iban) => {
  if (!iban || !iban.length) {
    return ''
  }
  const ibanArr = iban.trim().split('')
  let ibanStr = ibanArr.splice(0, 4).join('') + ' '
  while (ibanArr.length) {
    ibanStr += ibanArr.splice(0, 4).join('') + ' '
  }
  return ibanStr
}
